<template>
  <div>
    <div v-if="dataList && dataList.length>0">
      <div class="card-item" v-for="(item, index) in dataList" :key="index">
        <el-row class="row">
          <el-col :span="12" class="text-left">合同编号：<a class="goDetail" @click="goDetail('contract', item.id)">{{ item.contractNum }}</a></el-col>
          <el-col :span="12" class="text-right">商机：<a class="goDetail" @click="goDetail('business', item.businessId)">{{ item.businessName }}</a></el-col>
        </el-row>
        <el-row class="row table-title">
          <el-col :span="12" class="text-left">回款计划</el-col>
          <el-col :span="12" class="text-right">整体达成进度：{{ item.planFundListInfo.totalAchieveProgress }}%</el-col>
        </el-row>
        <el-table v-loading="loading" :data="item.planFundListInfo.planFundList">
          <el-table-column label="期数" align="center" prop="planFundBatch"/>
          <el-table-column label="款项名称" min-width="90" align="center" prop="paymentName"/>
          <el-table-column label="款项比例" min-width="100" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.paymentRatio }}%</span>
            </template>
          </el-table-column>
          <el-table-column label="计划回款日期" min-width="110" align="center" prop="planFundDate"/>
          <el-table-column label="计划回款金额（元）" min-width="130" align="center">
            <template slot-scope="scope">
              <span>{{ amountFormat(scope.row.planFundAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际回款金额（元）" min-width="130" align="center">
            <template slot-scope="scope">
              <span>{{ amountFormat(scope.row.actualAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="达成进度" min-width="100" align="center" prop="achieveProgress">
            <template slot-scope="scope">
              <span>{{ scope.row.achieveProgress }}%</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" min-width="100" :show-overflow-tooltip="true" prop="remark"/>
        </el-table>
        <el-row class="row table-title">
          <el-col :span="12" class="text-left">回款记录</el-col>
          <el-col :span="12" class="text-right">回款总额：{{ item.recordListInfo.totalFundAmount }}元</el-col>
        </el-row>
        <el-table v-loading="loading" :data="item.recordListInfo.fundRecordList">
          <el-table-column label="回款日期" min-width="110" align="center" prop="actualFundDate"/>
          <el-table-column label="回款金额（元）" min-width="100" align="center" prop="actualFundAmount"/>
          <el-table-column label="支付方式" min-width="100" align="center" prop="payType"/>
          <el-table-column label="回款银行" min-width="100" align="center" prop="bank"/>
          <el-table-column label="备注" min-width="130" :show-overflow-tooltip="true" prop="remark"/>
        </el-table>
      </div>
    </div>
    <el-empty v-else :image-size="100" style="margin-top: 100px"></el-empty>
  </div>
</template>

<script>
import {queryFundManageList} from "@/api/crm/contract";
import {amountFormat} from '@/utils/index'

export default {
  name: "PlanFundList",
  props: {
    customerId: {},
    contractId: {},
    height: {
      type: String,
      default() {
        return "250"
      }
    }
  },
  data() {
    return {
      loading: false,
      dataList: [],
      amountFormat,
      contractPlanFundId: null
    };
  },
  created() {
    if (this.customerId || this.contractId) {
      this.queryList();
    }
  },
  components: {},
  watch: {
    customerId(val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    },
    contractId(val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    }
  },
  methods: {
    goDetail(type, id) {
      let tempRoute = null
      if (type == 'contract') {
        tempRoute = this.$router.resolve({
          path: `/crm/contract/detail/${id}`
        });
      } else if (type == 'business') {
        tempRoute = this.$router.resolve({
          path: `/crm/business/detail/${id}`
        });
      }
      window.open(tempRoute.href, "_blank");
    },
    queryList() {
      this.loading = true;
      queryFundManageList({
        customerId: this.customerId
      }).then(response => {
        const {code, msg, rows} = response
        if (code == 200) {
          this.dataList = rows
        } else {
          this.$message.error(msg || '回款信息列表获取异常')
        }
        // this.$emit('after-query', this.dataList);
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        this.$message.error(error.msg || '回款信息列表获取异常')
      });
    },
    /** 详细按钮操作 */
    toContractDetail(row) {
      this.$router.push("/crm/contract/detail/" + row.contractId);
    },
    /** 详细按钮操作 */
    toDetail(row) {
      this.$router.push("/crm/plan-fund/detail/" + row.id);
    },
  }
};
</script>
<style lang="scss" scoped>
.card-item {
  padding: 20px;
  border: 1px solid #d9d9d9;
  margin-bottom: 20px;
  border-radius: 6px;
}

.text-left,
.text-right {
  .goDetail {
    color: #409eff;
  }
}

.text-right {
  text-align: right;
}

.table-title {
  margin: 15px 0;

  .text-left {
    padding-left: 10px;
    border-left: 5px solid #409eff;
  }
}
</style>
